import React, { useState, useEffect } from 'react';
import { useLanguage } from 'Context/LanguageContext';
import Grid from '@mui/material/Grid2';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ENDPOINTS } from '../../core/constants/pageEndpoints.constants';
import { selectSession } from '../../core/store/modules/session/sessionSelectors';
import AssetInventoryHeader from './components/AssetInventoryHeader';
import AssetInventoryTitles from './components/AssetInventoryTitles';
import CreateFieldsAssetInventory from './components/CreateFieldsAssetInventory';
import TemplateFilesGenerator from './components/TemplateFilesGenerator';
import EditForm from './EditForm';
import { checkCustomTemplateType } from './util';
import { Button } from '@mui/material';

const TaskInventories = ({
	inventories,
	activeInventory,
	inventoryHasImages,
	images,
	changeActiveInventory,
	client,
	timezone,
	reloadData,
	taskData,
	taskAgent,
	idAccountTask
}) => {
	const lan = useLanguage();
	const navigate = useNavigate();
	const session = useSelector(selectSession);
	const [editInventory, setEditInventory] = useState(false);
	const [customTemplateType, setCustomTemplateType] = useState({ xslx: false, html: false });
	const [showAssetInventoryFileField, setShowAssetFieldFile] = useState({});
	const [showAssetInventoryFileQuestion, setShowAssetFieldQuestion] = useState({});
	useEffect(() => {
		const customTypes = checkCustomTemplateType(inventories[activeInventory]);
		setCustomTemplateType(customTypes);
	}, [activeInventory, inventories]);
	const viewInventory = () => {
		const inventory = inventories[activeInventory];
		navigate(`${ENDPOINTS.inventory}?id=${inventory.id}`);
	};
	const editInventoryVisibility = () => {
		setEditInventory(!editInventory);
	};
	const getTextFile = async (question, isField) => {
		let getTextFromFile = () => {
			return new Promise((res, rej) => {
				let request = new XMLHttpRequest();
				request.open('GET', question.file, true);
				request.send();
				request.onreadystatechange = () => {
					if (request.readyState === 4 && request.status === '200') {
						let type = request.getResponseHeader('Content-Type');
						if (type.indexOf('text') !== 1) {
							res(request.response);
						}
					}
				};
			});
		};
		let text = await getTextFromFile();
		if (isField) {
			let showAssetField = {}
			showAssetField[question.id] = text
			setShowAssetFieldFile(Object.assign(showAssetField))
		} else {
			let showAssetQuestion = {}
			showAssetQuestion[question.id] = text
			setShowAssetFieldQuestion(Object.assign(showAssetQuestion))
		 }
	};
	const Header = (
		<AssetInventoryHeader
			isInventory
			showFormFile={showAssetInventoryFileField}
			assetInventories={inventories}
			activeAssetInventory={activeInventory}
			timezone={timezone}
			getTextFileHeader={getTextFile }
		/>
	);
	return (
    <Grid container>
			{editInventory && (
				<EditForm
					idAccountTask={idAccountTask}
					inventory={inventories[activeInventory]}
					onClose={editInventoryVisibility}
					Header={Header}
					taskId={taskData.idFielder}
					reloadData={reloadData}
					session={session}
					client={client}
					lan={lan}
					taskData={taskData}
				/>
			)}
      <Grid size={12} container sx={{ height: '70%', minHeight: '300px' }}>
				<Grid size={3}>
					<Scrollbars renderThumbHorizontal={(props) => <div {...props} style={{ display: 'none' }} />}>
						<AssetInventoryTitles
							assetInventories={inventories}
							activeAssetInventory={activeInventory}
							changeActiveAssetInventory={changeActiveInventory}
							client={client}
							editAssetInventoryVisibility={editInventoryVisibility}
							isInventory
						/>
					</Scrollbars>
				</Grid>
				<Grid size={9}>
					<Scrollbars renderThumbHorizontal={(props) => <div {...props} style={{ display: 'none' }} />}>
						<AssetInventoryHeader						
							showFormFile={showAssetInventoryFileField}
							assetInventories={inventories}
							activeAssetInventory={activeInventory}
							timezone={timezone}
							getTextFileHeader={getTextFile}
						/>
						<CreateFieldsAssetInventory
							assetInventories={inventories}
							activeAssetInventory={activeInventory}
							timezone={timezone}
							showFormFile={showAssetInventoryFileQuestion}
							getTextFileHeader={getTextFile }
						/>
					</Scrollbars>
				</Grid>
			</Grid>
      {inventories && (
        <Grid size={12} container spacing={1} direction="row" sx={{ alignItems: "center" }}>
          <Grid size={4}>
            <Button
              variant="outlined"
              onClick={viewInventory}
              size={'medium'}
            >
              {lan.viewInventory}
            </Button>
          </Grid>
          <Grid size={8}>
            <TemplateFilesGenerator
              customTemplateType={customTemplateType}
              taskData={taskData}
              taskAgent={taskAgent}
              inventory={inventories[activeInventory]}
              hasImages={inventoryHasImages}
              images={images}
            />
          </Grid>
        </Grid>
      )}
		</Grid>
	);
};
export default TaskInventories;
